module.exports = __webpack_public_path__ + "img/symbol_11.b202f07a.png";